<template>
  <div>
    <Upload
      :action="opts.url?opts.url:fileUploadPath"
      :before-upload="beforeUpload"
      :data="opts.data"
      :default-file-list="fileList"
      :disabled="disabled"
      :format="opts.format"
      :headers="headers"
      :max-size="1024 * maxSize"
      :multiple="opts.multiple != undefined?opts.multiple:false"
      :on-error="handleError"
      :on-exceeded-size="handleMaxSize"
      :on-format-error="handleFormatError"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-success="handleSuccess"
      :ref="ref"
      :show-upload-list="opts.showUploadList != undefined?opts.showUploadList:false"
      :type="opts.type || 'drag'"
      @clearFiles="clearFiles"
    >
      <slot name="uploadContent">
        <div v-if="opts.type == 'select'">
          <Button icon="ios-cloud-upload-outline">上传照片</Button>
        </div>
        <div style="padding: 20px 0" v-else>
          <Icon size="52" style="color: #3399ff" type="ios-cloud-upload"></Icon>
          <p>点击或拖拽文件到此处</p>
          <p style="color:#ddd; font-size: 0.7rem" v-if="opts.format">支持格式：{{opts.format.join('、')}}</p>
        </div>
      </slot>
    </Upload>
    <Spin fix v-if="showSpan">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <div>文件上传中，请稍候...</div>
    </Spin>
  </div>
</template>

<script>
import utils from "@/libs/utils"
export default {
  props: {
    opts: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ref: 'upload-' + new Date().getTime(),
      showSpan: false,
      maxSize: fileMaxSize,
      fileUploadPath: process.env.VUE_APP_API_ROOT + this.$apis.fileServerApi.uploadFile,
      getFile: process.env.VUE_APP_API_ROOT + this.$apis.fileServerApi.getFile,
      headers: {
        Authorization: utils.getToken(this.$apis.fileServerApi.uploadFile)
      },
      fileList: []
    }
  },
  watch: {
    opts: {
      handler (newValue, oldValue) {
        this.fileList = this.newValue?.defauleFiles || []
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clearFiles: function () {
      console.log("clearFiles")
    },
    beforeUpload: function () {
      this.showSpan = true
      return true
    },
    handleSuccess (res, file) {
      this.showSpan = false
      let _this = this
      console.log('handleSuccess', file)
      if (res.success) {
        let data = res.result || {}
        let url = data.url
        let file = {}
        if (this.opts.handlerType != 'base64') {
          url = data.url
          file = {
            name: data.originalName || data.fileName,
            url: url,
            fileId: data.id,
            fileSize: data.fileSize,
            baseUrl: data.url,
            fileType: data.fileType
          }
        } else {
          file = {
            name: data.originalName,
            url: url,
            fileId: data.id,
            baseUrl: url
          }
        }
        // this.userForm.avatarPath = data.url;
        if (this.opts.multiple != true) {
          this.fileList = []
        }
        this.fileList.push(file)
        if (_this.opts.successInfo != '') {
          this.$Message.success({
            duration: 5,
            closable: true,
            content: _this.opts.successInfo != undefined && _this.opts.successInfo != null ? _this.opts.successInfo : "文件上传成功！"
          })
        }

        this.$emit('uploadFile', this.fileList)
      } else {
        this.$Message.error({
          duration: 3,
          content: res.message
        })
        this.fileList = this.fileList.filter(item => item.uid != file.uid)
      }
      this.$emit('serviceHandleResult', res)
    },
    handleFormatError (file) {
      this.$Message.error("文件格式只能是" + this.opts.format.join("、") + "！")
      this.showSpan = false
    },
    handleMaxSize (file) {
      this.$Message.error("上传文件不超过" + fileMaxSize + "MB！")
      this.showSpan = false
    },
    handleError (res) {
      this.showSpan = false
      console.log("handleError", res)
      this.$Message.error("文件上传失败！")
    },
    onRemove (file, fileList) {
      console.log("file", file)
      console.log("fileList", fileList)
      let _this = this
      let params = new this.$URLSearchParams()
      params.append("ids", [file.fileId])
      this.$axios.post(this.$apis.fileServerApi.deletefiles, params).then(res => {
        if (res.success) {
          this.$emit('uploadFile', fileList)
          _this.$Message.success('文件删除成功！')
          return true
        } else {
          fileList.push(file)
          this.$Message.error(res.message)
          return false
        }
      }).catch(err => {
        console.log('beforeDelete err', err)
        fileList.push(file)
        _this.$Message.error('文件删除失败！')
        return false
      }).finally(() => {
        _this.fileList = fileList
      })

    },
    onPreview (file) {
      this.$emit('previewFile', file)
    }
  },
  beforeDestroy () {
    console.log('upload beforeDestroy')
    this.$refs[this.ref].clearFiles()
    this.fileList = []
  }
}
</script>